import dayjs from "dayjs";
import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { AssetsType, Product } from "@type/inventory/stock/assets";

export const AssetsListTableColumn = (
  t: TFunction<"translation", undefined>,
  language: string | null,
) => {
  return [
    {
      id: 1,
      key: "name",
      name: t("INVENTORY_STOCK.ASSETS.TABLE.COLUMN.NAME"),
      render: (name: string, row: AssetsType) => (
        <Text color="info" weight="semibold" className="text-nowrap">
          {language === "en"
            ? row.product?.name?.nameEn
            : row.product?.name?.nameBn}
        </Text>
      ),
    },
    {
      id: 2,
      key: "category",
      name: t("INVENTORY_STOCK.ASSETS.TABLE.COLUMN.CATEGORY"),
      render: (category: string, row: AssetsType) => (
        <Text color="subtitle2" className="text-nowrap">
          {row?.product?.name?.group?.category?.name
            ? row?.product?.name?.group?.category?.name
            : "..."}
        </Text>
      ),
    },
    {
      id: 3,
      key: "group",
      name: t("INVENTORY_STOCK.ASSETS.TABLE.COLUMN.GROUP"),
      render: (group: string, row: AssetsType) => (
        <Text color="subtitle2">
          {row?.product?.name?.group?.name
            ? row?.product?.name?.group?.name
            : "..."}
        </Text>
      ),
    },
    {
      id: 4,
      key: "brand",
      name: t("INVENTORY_STOCK.ASSETS.TABLE.COLUMN.BRAND"),
      render: (brand: string, row: AssetsType) => (
        <Text color="subtitle2">
          {row.product?.name?.brand?.name
            ? row?.product?.name?.brand?.name
            : "..."}
        </Text>
      ),
    },
    {
      id: 5,
      key: "unitPrice",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.ASSETS.TABLE.COLUMN.OFFICE"),
      render: (unitPrice: string, row: AssetsType) => (
        <Text color="subtitle2">
          {row?.office?.name ? row?.office?.name : "..."}
        </Text>
      ),
    },
    {
      id: 6,
      key: "unitPrice",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.ASSETS.TABLE.COLUMN.BUILDING"),
      render: (unitPrice: string, row: AssetsType) => (
        <Text color="subtitle2">
          {row?.building?.buildingName ? row?.building?.buildingName : "..."}
        </Text>
      ),
    },
    {
      id: 7,
      key: "serialNo",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.ASSETS.TABLE.COLUMN.ROOM"),
      render: (unitPrice: string, row: AssetsType) => (
        <Text color="subtitle2">
          {row?.room?.roomNo ? row?.room?.roomNo : "..."}
        </Text>
      ),
    },
    {
      id: 8,
      key: "lotNo",
      name: t("INVENTORY_STOCK.ASSETS.TABLE.COLUMN.LOT_NO"),
      render: (lotNo: string, row: AssetsType) => (
        <Text color="subtitle2">
          {row?.product?.lotNo ? row?.product?.lotNo : "..."}
        </Text>
      ),
    },
    {
      id: 9,
      key: "tagNo",
      name: t("INVENTORY_STOCK.ASSETS.TABLE.COLUMN.TAG_NO"),
      render: (tagNo: string) => (
        <Text color="subtitle2">{tagNo ? tagNo : "..."}</Text>
      ),
    },
  ];
};
